module.exports = __webpack_public_path__ + "img/lock-on.33ac390a.webp";